import { apiClient } from '../index';


/**
 * [crea el payment intent]
 * @return {[type]}         
 */
 function createPymtIntent({id, customerId, concept, totaltc }) {
  
  const params = { id, customerId, concept, amount:totaltc };
  console.log(params);
  return apiClient.post(`/v1/stripe/create-payment-intent`, params);
}

/**
 * [confirma el pago en stripe]
 * @return {[type]}         
 */
 function confirmPymtIntent( paymentIntentId ) {
  const params = { paymentIntentId};
  return apiClient.post(`/v1/stripe/confirm-payment-intent`, params);
}

/**
 * [confirma el pago en stripe]
 * @return {[type]}         
 */
 function confirmPayment( paymentIntentId ) {
  const params = { paymentIntentId};
  return apiClient.post(`/v1/stripe/confirm-payment`, params);
}

/**
 * [confirma el pago en stripe]
 * @return {[type]}         
 */
 function getStripeEvent( paymentId ) {  
  return apiClient.post(`/v1/stripe/getpayment`, { paymentId });
}

export default {
  createPymtIntent,
  confirmPymtIntent,
  confirmPayment,
  getStripeEvent
}